import { gql } from "apollo-boost";
import { idtype, seomatic } from "querypieces";

export default gql`
  query($uri: String) {
    entry(uri: [$uri]) {
      ... on search_Entry {
        id
        heading
        plainText
        body
        introBody
        subheader

        siteMap {
          ... on siteMap_linkList_BlockType {
            ${idtype}
            children {
              ... on siteMap_pageLinks_BlockType {
                ${idtype}
                altText
                linkTo {
                  element {
                    ... on page_Entry {
                      level
                      id
                      title
                      uri
                      children {
                        ... on page_Entry {
                          id
                          title
                          uri
                        }
                      }
                    }
                    ... on contact_Entry {
                      level
                      id
                      heading
                      title
                      uri
                    }
                    ... on news_Entry {
                      level
                      id
                      heading
                      uri
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    ${seomatic}
  }
`;
